// components
import { Typography } from '@centria-ui/components/atoms/typography'

// prime components
import { Calendar as PrCalendar } from 'primereact/calendar'

// hooks
import { usePrimereact } from '@centria-ui/hooks/use-prime'

// styles
import classes from './styles.module.scss'

// type
import type {
  sizeEnums,
  InputsEnum,
  variantsEnum
} from '@centria-ui/commons/enums'
import type { CalendarProps as PrCalendarProps } from 'primereact/calendar'
import type { FC, RefObject } from 'react'

export type CalendarProps = PrCalendarProps & {
  label?: string
  border?: boolean
  panelSize?: keyof typeof sizeEnums
  calendarRef?: RefObject<PrCalendar>
  inputVariant?: keyof typeof InputsEnum
  inputColor?: typeof variantsEnum.light | typeof variantsEnum.white
}

export const Calendar: FC<CalendarProps> = ({
  label,
  border,
  locale,
  calendarRef,
  className = '',
  panelSize = 'sm',
  panelClassName = '',
  inputClassName = '',
  inputColor = 'light',
  showButtonBar = true,
  inputVariant = 'block',
  ...props
}) => {
  const { locale: PrLocale } = usePrimereact()

  return (
    <div data-cy='calendar' className='w-100 align-items-center'>
      {label && (
        <Typography
          Tag='label'
          fontSize='small'
          className='mb-1'
          htmlFor={props.id}>
          {label}
        </Typography>
      )}
      <PrCalendar
        required
        {...props}
        ref={calendarRef}
        dateFormat='dd/mm/yy'
        locale={locale ?? PrLocale}
        showButtonBar={showButtonBar}
        panelClassName={`${panelClassName} ${classes.panel} ${
          classes[`panel_${panelSize}`]
        }`}
        className={`${className} ${classes.calendar} ${
          props.selectionMode === 'range'
            ? classes.calendar_range
            : classes.calendar_single
        }`}
        inputClassName={`${classes.input} ${
          border && classes.calendar_border
        } ${classes[`input_${inputVariant}`]} ${
          classes[`input_${inputColor}`]
        }`}
      />
    </div>
  )
}
